exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rednaoRepeater{\r\n    margin:15px 0;\r\n}\r\n\r\n.rednaoRepeater .rnTitle{\r\n    margin:0;\r\n}", ""]);

// exports
